import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { TextButton } from './TextButton';
import { navLinks } from '../data/site';
import { smsMessages } from '../utils/sms';
export function Header() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return <header className="sticky top-0 z-40 border-b border-ink-950/8 bg-paper/90 backdrop-blur-md" data-id="element-73" data-mp="2rkb6h5heckn2">
      <div className="mx-auto flex h-24 max-w-shell items-center justify-between px-5 sm:px-8 lg:h-36" data-id="element-74" data-mp="2wivzajubk21h">
        <Link to="/" aria-label="Hydrosprings home" className="-my-2 inline-flex items-center py-2" data-id="element-75" data-mp="36b1zuhymzrsa">
          <Logo className="h-20 lg:h-32" data-id="element-76" data-mp="3bb67dihkhc6d" />
        </Link>

        <nav aria-label="Main" className="hidden items-center gap-8 md:flex" data-id="element-77" data-mp="3fbq3ciqem9qx">
          {navLinks.map(link => <NavLink key={link.to} to={link.to} className={({
          isActive
        }) => `text-sm transition-colors duration-150 ease-smooth ${isActive ? 'text-ink-950' : 'text-ink-700 hover:text-ink-950'}`} data-id="element-78" data-mp="2wlduzk2oyv7n">
              {link.label}
            </NavLink>)}
        </nav>

        <div className="hidden md:block" data-id="element-79" data-mp="3fa10g3os5mlr">
          <TextButton message={smsMessages.general} size="sm" data-id="element-80" data-mp="3fd6rvpkvt0kn">
            Text us
          </TextButton>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} className="-mr-2 rounded-full p-2 text-ink-950 transition-colors duration-150 ease-smooth hover:bg-ink-950/5 md:hidden" data-id="element-81" data-mp="35l0xyab2k92t">
          {open ? <XIcon className="h-5 w-5" data-id="element-82" data-mp="3tabsha1tt78i" /> : <MenuIcon className="h-5 w-5" data-id="element-83" data-mp="1rdth0a33spb8" />}
        </button>
      </div>

      {open && <div className="border-t border-ink-950/8 bg-paper px-5 pb-6 pt-2 md:hidden" data-id="element-84" data-mp="1wcee40n26svg">
          <nav aria-label="Mobile" className="flex flex-col" data-id="element-85" data-mp="1hnrq7ajd8ssm">
            {navLinks.map(link => <NavLink key={link.to} to={link.to} className="border-b border-ink-950/8 py-3.5 font-display text-lg text-ink-950" data-id="element-86" data-mp="1mml619m4kvvy">
                {link.label}
              </NavLink>)}
          </nav>
          <TextButton message={smsMessages.general} size="md" className="mt-5 w-full" data-id="element-87" data-mp="1cmkjlesylznj">
            Text us
          </TextButton>
        </div>}
    </header>;
}